var _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailEnvelope = function SvgEmailEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 36 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D0D5DA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6.811v16.541c0 1.151.416 2.194 1.084 3.028l11.447-9.125L0 6.811ZM34.916 26.379A4.82 4.82 0 0 0 36 23.351V6.811L23.468 17.254l11.448 9.125Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.688 16.931 0 6.811l12.532 10.443 2.156 1.797c1.994 1.546 4.63 1.546 6.625 0l2.156-1.797L36.001 6.811l-14.688 10.12a5.84 5.84 0 0 1-6.625 0Z",
    fill: "#AFB7C0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#E5E9EE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.312 19.051c-1.994 1.546-4.63 1.546-6.625 0l-2.156-1.797-11.447 9.125c.892 1.111 2.245 1.837 3.78 1.837h26.27c1.536 0 2.889-.726 3.78-1.837l-11.447-9.125-2.155 1.797Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 0H5a5 5 0 0 0-5 5v1.811l14.688 10.12a5.84 5.84 0 0 0 6.625 0l14.688-10.12V5c0-2.761-2.24-5-5.001-5Z"
  }))));
};
export default SvgEmailEnvelope;